import { defineMessages } from 'react-intl';

export default defineMessages({
    HomeDetails: {
        id: 'policy.ho.directives.policy-dwelling-info.Home Details',
        defaultMessage: 'Home Details'
    },
    DistanceToFireHydrant: {
        id: 'policy.ho.directives.policy-dwelling-info.Distance To Fire Hydrant',
        defaultMessage: 'Distance to Fire Hydrant'
    },
    DistanceToFireStation: {
        id: 'policy.ho.directives.policy-dwelling-info.Distance To Fire Station',
        defaultMessage: 'Distance to Fire Station'
    },
    FeetToFireHydrant: {
        id: 'policy.ho.directives.policy-dwelling-info.Feet To Fire Hydrant',
        defaultMessage: '{distance} ft'
    },
    MilesToFireStation: {
        id: 'policy.ho.directives.policy-dwelling-info.Miles',
        defaultMessage: '{miles} miles'
    },
    FloodingorFireHazard: {
        id: 'policy.ho.directives.policy-dwelling-info.Flooding or Fire Hazard',
        defaultMessage: 'Flooding or Fire Hazard'
    },
    WithinftofCommercialProperty: {
        id: 'policy.ho.directives.policy-dwelling-info.Within 300ft of Commercial Property',
        defaultMessage: 'Within 300ft of Commercial Property'
    },
    LocationType: {
        id: 'policy.ho.directives.policy-dwelling-info.Location Type',
        defaultMessage: 'Location Type'
    },
    ResidenceType: {
        id: 'policy.ho.directives.policy-dwelling-info.Residence Type',
        defaultMessage: 'Residence Type'
    },
    Homeisusedas: {
        id: 'policy.ho.directives.policy-dwelling-info.Home Type',
        defaultMessage: 'Home Type'
    },
    DwellingOccupied: {
        id: 'policy.ho.directives.policy-dwelling-info.Dwelling Occupied',
        defaultMessage: 'Dwelling Occupied'
    },
    Mortgagee: {
        id: 'policy.ho.directives.policy-dwelling-info.Mortgagee',
        defaultMessage: 'Mortgagee'
    },
    MortgageeName: {
        id: 'policy.ho.directives.policy-dwelling-info.Mortgagee Name',
        defaultMessage: 'Name'
    },
    MortgageeStreet: {
        id: 'policy.ho.directives.policy-dwelling-info.Mortgagee Street',
        defaultMessage: 'Street'
    },
    MortgageeCity: {
        id: 'policy.ho.directives.policy-dwelling-info.Mortgagee City',
        defaultMessage: 'City'
    },
    MortgageeState: {
        id: 'policy.ho.directives.policy-dwelling-info.Mortgagee State',
        defaultMessage: 'State'
    },
    ConstructionDetails: {
        id: 'policy.ho.directives.policy-dwelling-info.Construction Details',
        defaultMessage: 'Construction Details'
    },
    YearBuilt: {
        id: 'policy.ho.directives.policy-dwelling-info.Year Built',
        defaultMessage: 'Year Built'
    },
    ofStories: {
        id: 'policy.ho.directives.policy-dwelling-info.No of Stories',
        defaultMessage: 'No. of Stories'
    },
    Garage: {
        id: 'policy.ho.directives.policy-dwelling-info.Garage',
        defaultMessage: 'Garage'
    },
    ConstructionType: {
        id: 'policy.ho.directives.policy-dwelling-info.Construction Type',
        defaultMessage: 'Construction Type'
    },
    FoundationType: {
        id: 'policy.ho.directives.policy-dwelling-info.Foundation Type',
        defaultMessage: 'Foundation Type'
    },
    RoofType: {
        id: 'policy.ho.directives.policy-dwelling-info.Roof Type',
        defaultMessage: 'Roof Type'
    },
    RoofMaterial: {
        id: 'policy.ho.directives.policy-dwelling-info.Roof Material',
        defaultMessage: 'Roof Material'
    },
    RoofUpgraded: {
        id: 'policy.ho.directives.policy-dwelling-info.Roof Upgraded',
        defaultMessage: 'Roof Upgraded'
    },
    PlumbingType: {
        id: 'policy.ho.directives.policy-dwelling-info.Plumbing Type',
        defaultMessage: 'Plumbing Type'
    },
    PlumbingUpgraded: {
        id: 'policy.ho.directives.policy-dwelling-info.Plumbing Upgraded',
        defaultMessage: 'Plumbing Upgraded'
    },
    PrimaryHeatingType: {
        id: 'policy.ho.directives.policy-dwelling-info.Primary Heating Type',
        defaultMessage: 'Primary Heating Type'
    },
    HeatingUpgraded: {
        id: 'policy.ho.directives.policy-dwelling-info.Heating Upgraded',
        defaultMessage: 'Heating Upgraded'
    },
    WiringType: {
        id: 'policy.ho.directives.policy-dwelling-info.Wiring Type',
        defaultMessage: 'Wiring Type'
    },
    ElectricalSystem: {
        id: 'policy.ho.directives.policy-dwelling-info.Electrical System Amp',
        defaultMessage: 'Electrical System Amp'
    },
    TotalTaxes: {
        id: 'policy.ho.directives.policy-dwelling-info.Total Taxes',
        defaultMessage: 'Total Taxes'
    },
    TotalCost: {
        id: 'policy.ho.directives.policy-dwelling-info.Total Cost',
        defaultMessage: 'Total Cost'
    },
    ElectricalUpgraded: {
        id: 'policy.ho.directives.policy-dwelling-info.Electrical Upgraded',
        defaultMessage: 'Electrical Upgraded'
    },
    ProtectionDetails: {
        id: 'policy.ho.directives.policy-dwelling-info.Protection Details',
        defaultMessage: 'Protection Details'
    },
    FireExtinguisher: {
        id: 'policy.ho.directives.policy-dwelling-info.Fire Extinguisher',
        defaultMessage: 'Fire Extinguisher'
    },
    BurglarAlarmSystem: {
        id: 'policy.ho.directives.policy-dwelling-info.Burglar Alarm System',
        defaultMessage: 'Burglar Alarm System'
    },
    MonitoringCenterFireAlarm: {
        id: 'policy.ho.directives.policy-dwelling-info.Monitoring Center Fire Alarm',
        defaultMessage: 'Monitoring Center Fire Alarm'
    },
    SmokeAlarms: {
        id: 'policy.ho.directives.policy-dwelling-info.Fire/Smoke Alarm',
        defaultMessage: 'Fire/Smoke Alarm'
    },
    PolicyType: {
        id: 'policy.ho.directives.policy-dwelling-info.Policy Type',
        defaultMessage: 'Policy Type'
    },
    DeadBolts: {
        id: 'policy.ho.directives.policy-dwelling-info.Dead Bolts',
        defaultMessage: 'Deadbolts'
    },
    ResidenceVisibletoNeighbours: {
        id: 'policy.ho.directives.policy-dwelling-info.Residence Visible to Neighbours',
        defaultMessage: 'Residence Visible to Neighbours'
    },
    SprinklerSystem: {
        id: 'policy.ho.directives.policy-dwelling-info.Sprinkler System',
        defaultMessage: 'Sprinkler System'
    },
    RoomersAndBorders: {
        id: 'policy.ho.directives.policy-dwelling-info.No. of Roomers and Borders?',
        defaultMessage: 'No. of Roomers and Borders?'
    },
    ofUnits: {
        id: 'policy.ho.directives.policy-dwelling-info.No. of Units/ Apartments',
        defaultMessage: 'No. of Units/ Apartments'
    },
    FireplaceorWoodstove: {
        id: 'policy.ho.directives.policy-dwelling-info.Fireplace or Woodstove',
        defaultMessage: 'Fireplace or Woodstove'
    },
    SwimmingPool: {
        id: 'policy.ho.directives.policy-dwelling-info.Is there a Swimming Pool?',
        defaultMessage: 'Is there a Swimming Pool?'
    }, 
    FireProtection: {
        id: 'policy.ho.directives.policy-dwelling-info.Fire Protection?',
        defaultMessage: 'Fire Protection'
    }, 
    Trampoline: {
        id: 'policy.ho.directives.policy-dwelling-info.Trampoline',
        defaultMessage: 'Trampoline'
    },
    RoadAccessibleYearRound: {
        id: 'policy.ho.directives.policy-dwelling-info.Road Accessible Year Round',
        defaultMessage: 'Road Accessible Year Round'
    },
    FloodingWaterLeakinpastYears: {
        id: 'policy.ho.directives.policy-dwelling-info.Flooding/Water Leak in past 5 Years',
        defaultMessage: 'Flooding/Water Leak in past 5 Years'
    },
    Coverages: {
        id: 'policy.ho.directives.policy-dwelling-info.Coverages',
        defaultMessage: 'Coverages'
    },
    SectionICoverages: {
        id: 'policy.ho.directives.policy-dwelling-info.Section I Coverages',
        defaultMessage: 'Section I Coverages'
    },
    SectionIICoverages: {
        id: 'policy.ho.directives.policy-dwelling-info.Section II Coverages',
        defaultMessage: 'Section II Coverages'
    },
    AdditionalLiabilityCoverages: {
        id: 'policy.ho.directives.policy-dwelling-info.Additional Liability Coverages',
        defaultMessage: 'Additional Liability Coverages'
    },
    AdditionalPropertyCoverages: {
        id: 'policy.ho.directives.policy-dwelling-info.Additional Property Coverages',
        defaultMessage: 'Additional Property Coverages'
    }, 
    HideCoverages: {
        id: 'policy.ho.directives.policy-dwelling-info.Hide Coverages',
        defaultMessage: 'Hide Coverages'
    },
    ShowCoverages: {
        id: 'policy.ho.directives.policy-dwelling-info.Show Coverages',
        defaultMessage: 'Show Coverages'
    },
    HideBuildingCoverages: {
        id: 'policy.ho.directives.policy-dwelling-info.Hide Bulding Coverages',
        defaultMessage: 'Hide Building Coverages'
    },
    ShowBuildingCoverages: {
        id: 'policy.ho.directives.policy-dwelling-info.Show Building Coverages',
        defaultMessage: 'Show Building Coverages'
    },
    ScheduledItems: {
        id: 'policy.ho.directives.policy-dwelling-info.Scheduled Items',
        defaultMessage: 'Scheduled Items'
    },
    infoYes: {
        id: 'policy.ho.directives.policy-dwelling-info.Yes',
        defaultMessage: 'Yes'
    },
    infoNo: {
        id: 'policy.ho.directives.policy-dwelling-info.No',
        defaultMessage: 'No'
    },
    generalDetails: {
        id: 'policy.ho.directives.policy-dwelling-info.General Details',
        defaultMessage: 'General Details'
    },

    isThereAHotTub: {
        id: 'policy.ho.directives.policy-dwelling-info.Is there a hot tub?',
        defaultMessage: 'Is there a hot tub?'
    },
    noOfPonds: {
        id: 'policy.ho.directives.policy-dwelling-info.No. of Ponds',
        defaultMessage: 'No. of Ponds'
    },
    buildingArea: {
        id: 'policy.ho.directives.policy-dwelling-info.Building area (in sq ft)',
        defaultMessage: 'Building area (in sq ft)'
    },
    basementFinished: {
        id: 'policy.ho.directives.policy-dwelling-info.Basement Finished',
        defaultMessage: 'Basement Finished'
    },

    fullTimeFireDepartment :{
        id: 'policy.ho.directives.policy-dwelling-info.Full Time Fire Department',
        defaultMessage:'Full Time Fire Department'
    },
    superiorShuttle: {
        id: 'policy.ho.directives.policy-dwelling-info.Superior Shuttle',
        defaultMessage: 'Superior Shuttle'
    },
    roadAccessibleYearRound: {
        id: 'policy.ho.directives.policy-dwelling-info.Road Accessible Year Round',
        defaultMessage: 'Road Accessible Year Round'
    },

    noHull: {
        id: 'policy.ho.directives.policy-dwelling-info.No Hull',
        defaultMessage: 'No Hull'
    },

    hullIDSerialNumber: {
        id: 'policy.ho.directives.policy-dwelling-info.Hull ID/Serial Number',
        defaultMessage: 'Hull ID/Serial Number'
    },

    boatType: {
        id: 'policy.ho.directives.policy-dwelling-info.Boat Type',
        defaultMessage: 'Boat Type'
    },

    boatYear: {
        id: 'policy.ho.directives.policy-dwelling-info.Boat Year',
        defaultMessage: 'Boat Year'
    },

    boatLength : {
        id: 'policy.ho.directives.policy-dwelling-info.Boat Length (ft)',
        defaultMessage: 'Boat Length (ft)'
    },

    make: {
        id: 'policy.ho.directives.policy-dwelling-info.Make',
        defaultMessage: 'Make'
    },

    model: {
        id: 'policy.ho.directives.policy-dwelling-info.Model',
        defaultMessage: 'Model'
    },

    boatSpeed: {
        id: 'policy.ho.directives.policy-dwelling-info.Boat Speed',
        defaultMessage: 'Boat Speed'
    },

    horsePower: {
        id: 'policy.ho.directives.policy-dwelling-info.Horse Power (hp)',
        defaultMessage: 'Horse Power (hp)'
    },

    boatValue: {
        id: 'policy.ho.directives.policy-dwelling-info.Boat Value',
        defaultMessage: 'Boat Value'
    },
    hullType: {
        id: 'policy.ho.directives.policy-dwelling-info.Hull Type',
        defaultMessage: 'Hull Type'
    },
    certificate: {
        id: 'policy.ho.directives.policy-dwelling-info.Do you have a certificate',
        defaultMessage: 'Do you have a certificate'
    },

    year: {
        id: 'policy.ho.directives.policy-dwelling-info.Year',
        defaultMessage: 'Year'
    },
    vinSerial: {
        id: 'policy.ho.directives.policy-dwelling-info.VIN / Serial #',
        defaultMessage: 'VIN / Serial #'
    },
    Value: {
        id: 'policy.ho.directives.policy-dwelling-info.Value',
        defaultMessage: 'Value'
    },
    trailerPermanentlyParked: {
        id: 'policy.ho.directives.policy-dwelling-info.Is the Trailer permanently parked?',
        defaultMessage: 'Is the Trailer permanently parked?'
    },
    
    length: {
        id: 'policy.ho.directives.policy-dwelling-info.Length (ft)',
        defaultMessage: 'Length (ft)'
    },
    PrimaryFuelType: {
        id: 'policy.ho.directives.policy-dwelling-info.Primary Fuel Type',
        defaultMessage: 'Primary Fuel Type'
    },
    PrimaryConstructionClass: {
        id: 'policy.ho.directives.policy-dwelling-info.Primary Construction Class',
        defaultMessage: 'Primary Construction Class'
    },
    occupancyType: {
        id: 'policy.ho.directives.policy-dwelling-info.Occupancy Type',
        defaultMessage: 'Occupancy Type'
    },
    propertyOrOccupancy: {
        id: 'policy.ho.directives.policy-dwelling-info.Property/Occupancy Type',
        defaultMessage: 'Property/Occupancy Type'
    }
});
